import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LegalRepresentative} from '../../../account/models/LegalRepresentative';

@Component({
  selector: 'app-options-component',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss']
})
export class OptionsComponent implements OnInit {
  isEditable: boolean;

  @Input()
  public rowData: LegalRepresentative;
  @Input()
  public value: string | number;

  @Output() inactivate: EventEmitter<any> = new EventEmitter<any>();
  @Output() delete: EventEmitter<any> = new EventEmitter<any>();
  @Output() sendInvite: EventEmitter<any> = new EventEmitter<any>();
  @Output() save: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    this.isEditable = this.value === 'Draft';
  }

  doInactivate() {
    this.inactivate.emit(this.rowData);
  }

  doDelete() {
    this.delete.emit(this.rowData);
  }

  doSendInvite() {
    this.sendInvite.emit(this.rowData);
  }

  doSave() {
    console.log(this.rowData, this.value)
    this.save.emit(this.rowData);
  }

  isStatusPending(): boolean {
    return this.rowData && this.rowData.status === 'PENDING';
  }

  isStatusActive(): boolean {
    return this.rowData && this.rowData.status === 'ACTIVE';
  }
}
